import React from 'react'
import heroimg from "../assets/heroimg.jpeg"
import { MdFullscreen, MdOutlineKeyboardArrowRight } from "react-icons/md"
import { Link } from 'react-scroll'

const Home = () => {
    return (
        <div name="home"
            className="h-screen w-full bg-fixed bg-center bg-cover"
            style={{ backgroundImage: "url(/images/Background.jpeg)", backgroundRepeat: 'no-repeat' }}>

            <div className='max-w-screen-lg mx-auto flex flex-col items-center justify-center h-full px-4 md:flex-row'>
                {/* Paragraph */}
                <div className='md:my-auto flex flex-col justify-center h-full mx-4'>
                    <h2 className='text-4xl sm:text-7xl font-bold text-white '
                        style={{ textShadow: '0 0 6px #b2b5b9' }}
                    >I'm Matthew</h2>
                    <p className='text-gray-500 py-4 max-w-md'>
                        Aspiring Developer & BCIT Computer Systems Technology Student
                    </p>
                    {/* <p className='text-md w-64'>Is it that time of the year again where <b>you</b> are engaged in the process of solving that soul-searching question of
                    </p> */}

                    <h2 className='text-xl font-bold text-white'
                        style={{ textShadow: '0 0 6px #b2b5b9' }}
                    >What idea can I help you create?</h2>

                    {/* button */}
                    <div className='flex'>
                        <Link to="about" smooth duration={500} className=' group text-white w-fit px-6 py-3 my-2 flex items-center rounded-md bg-gradient-to-r 
                    bg-white/40 cursor-pointer'>
                            About
                            <span className='group-hover:rotate-90 duration-300'>
                                <MdOutlineKeyboardArrowRight size={25} className="ml-1" />
                            </span>
                        </Link>

                        <Link to="portfolio" smooth duration={500} className=' group text-white w-fit mx-2 px-6 py-3 my-2 flex items-center rounded-md bg-gradient-to-r 
                    bg-white/10 cursor-pointer'>
                            Portfolio
                            <span className='group-hover:rotate-90 duration-300'>
                                <MdOutlineKeyboardArrowRight size={25} className="ml-1" />
                            </span>
                        </Link>
                    </div>
                </div>
                
                {/* img */}
                {/* <div>
                <img className='rounded-2xl mx-auto w-2/3 md:w-full' src={heroimg} />
            </div> */}
            </div>
        </div>
    )
}

export default Home